import { render, staticRenderFns } from "./DisplayNote.vue?vue&type=template&id=336043e8&scoped=true&"
import script from "./DisplayNote.vue?vue&type=script&lang=js&"
export * from "./DisplayNote.vue?vue&type=script&lang=js&"
import style0 from "./DisplayNote.vue?vue&type=style&index=0&id=336043e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336043e8",
  null
  
)

export default component.exports